import { createContext, useContext, useState } from "react";
import CustomFormPage from "../components/common/CustomFormPage";
import { Card, Fade, Modal, Typography, Box } from "@mui/material";

const ModalContext = createContext({});

export function ModalContextProvider({ children }) {
    const [title, setTitle] = useState("Modal");
    const [isOpen, setIsOpen] = useState(false);

    const [isImage, setIsImage] = useState(false);
    const [image, setImage] = useState(false);

    const [formFieldList, setFormFieldList] = useState([{}]);
    const [initialData, setInitialData] = useState({});
    const [isDetails, setIsDetails] = useState(false);
    const [avatarUpload, setAvatarUpload] = useState(false);
    const [multiImageUpload, setMultiImageUpload] = useState(false);

    const [onSubmitHandler, setOnSubmitHandler] = useState(() => () => { });

    const handleClose = () => {
        setIsOpen(false);
        setTitle("Modal");
        setFormFieldList([]);
        setInitialData({});
        setIsDetails(false);
        setAvatarUpload(false);
        setMultiImageUpload(false);
        setIsImage(false);
        setImage(false);
        setOnSubmitHandler(() => () => { });
    };

    const handleOpen = () => formFieldList && setIsOpen(true);

    const handleUpdateFormFieldList = (data) => setFormFieldList(data);
    const handleUpdateInitialData = (data) => setInitialData(data);

    const handleSubmit = (formData) => {
        if (typeof onSubmitHandler === "function") {
            onSubmitHandler(formData);
            handleClose();
        }
    };

    const value = {
        setIsImage,
        setImage,
        image,
        handleOpen,
        handleClose,
        setIsDetails,
        setAvatarUpload,
        setMultiImageUpload,
        setModalTitle: setTitle,
        setFormFieldList: handleUpdateFormFieldList,
        setInitialData: handleUpdateInitialData,
        setOnSubmitHandler,
    };

    const styles = {
        modalCard:
        {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80vw',
            boxShadow: 24,
            maxHeight: '80vh',
            overflowY: 'scroll',
            p: 3,
        },
        image:
        {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            boxShadow: 24,
            maxHeight: '80vh',
            outline: 'none'
        }

    };

    const GlobalModal = () => {
        return (
            <Modal open={isOpen} onClose={handleClose} closeAfterTransition >
                <Fade in={isOpen}>

                    {
                        isImage ?

                            <Box component={'img'} sx={styles.image} borderRadius={1} src={image} />
                            :
                            <Card sx={styles.modalCard}>
                                <Typography mb={'1rem'} variant="h5" component="h2">
                                    {title}
                                </Typography>
                                <CustomFormPage
                                    details={isDetails}
                                    onCancel={handleClose}
                                    onSubmit={handleSubmit}
                                    multiImageUpload={multiImageUpload}
                                    avatarUpload={avatarUpload}
                                    formFieldList={formFieldList}
                                    initialData={initialData}
                                />
                            </Card>
                    }
                </Fade>
            </Modal>
        );
    };

    return (
        <ModalContext.Provider value={value}>
            <GlobalModal />
            {children}
        </ModalContext.Provider>
    );
}

export function useModal() {
    return useContext(ModalContext);
}
